<div class="input-group mb-3">
    <textarea #newCommentTextArea type="text" class="form-control" id="newCommentTextArea" placeholder="New comment..." rows="1"></textarea>
    <button class="btn btn-primary" style="border-top-right-radius: .2rem; border-bottom-right-radius: .2rem;" (click)="postComment(newCommentTextArea.value); newCommentTextArea.value = '';">
        <i class="fas fa-plus-circle"></i> Post
    </button>
</div>